<template lang="html">

  <section class="tu-perfil" v-if="series[0] != 0 || series[1] != 0">

    <div class="container row-between">

      <div class="contenedor-grafico">
        <apexchart type=donut width=350 :options="chartOptions" :series="series" />
        <img src="/static/img/tarifa-punta-icon.svg" class="tarifa-punta">
        <img src="/static/img/tarifa-valle-icon.svg" class="tarifa-valle">
      </div>

      <div class="contenedor-texto">

        <h2><span class="-orange">Tu perfil</span><span></span></h2>

        <h4>Según tu información <template v-if="results[1] > results[0]">te conviene una tarifa con discriminación horaria (DH).</template></h4>

        <p>Este es tu perfil aproximado de consumo anual:</p>

        <div class="consumos row-center">

          <article>
            <h4 class="-purple">VALLE: {{series[1]}} kWh</h4>
            <p>Consumo aprox. En valle (22 a 12h)</p>
          </article>

          <article>
            <h4 class="-dark-orange">PUNTA: {{series[0]}} kWh</h4>
            <p>Consumo aprox. En punta (12 a 22h)</p>
          </article>

        </div>



      </div>

    </div>

  </section>

</template>

<script lang="js">

  import VueApexCharts from 'vue-apexcharts'

  export default  {
    name: 'grafica-tu-perfil',
    props :['results'],
    mounted(){

      this.series = this.results;

      setTimeout(e => {
        this.calcularpos();
      },500)

      $(window).resize(e =>{
        this.calcularpos();
      });
    },
    components: {
      apexchart: VueApexCharts,
    },
    methods : {
      calcularpos(){
        let pos1 = { x: '', y : ''};
        let pos2 = { x: '', y : ''};

        pos1.x = Number($(".apexcharts-pie-label:first-of-type").attr('x'));
        pos1.y = Number($(".apexcharts-pie-label:first-of-type").attr('y'));

        pos2.x = Number($(".apexcharts-pie-label:last-of-type").attr('x'));
        pos2.y = Number($(".apexcharts-pie-label:last-of-type").attr('y'));

        let diference = Number(($(".contenedor-grafico").width() - $(".tu-perfil svg").width()) / 2) - 10;

        $(".tarifa-punta").attr('style',`left:${pos1.x+diference}px;top:${pos1.y - 90}px`);
        $(".tarifa-valle").attr('style',`left:${pos2.x+diference}px;top:${pos2.y - 90}px`);

        $(".tarifa-punta").addClass('show');
        $(".tarifa-valle").addClass('show');
      }
    },
    data(){
      return {
        series: [],
        chartOptions: {
          colors: ['#EB5F0C', '#5E639F'],
          // labels: ['Valle', 'Punta'],
          animations : {
            enabled : true,
            animateGradually : {
              enabled : true
            }
          },
          stroke : {
            show : true,
            width : 22,
            colors: ['white']
          },
          plotOptions: {
            pie: {
              expandOnClick: false
            }
          },
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 300
              },
              legend: {
                position: 'bottom'
              }
            }
          }]
        }
      }
    } 
  }
</script>

<style scoped lang="scss">

  @import '@/assets/css/colors.scss';

  .tu-perfil{
    padding-top: 100px;
  }

  .contenedor-grafico{
    position: relative;
    display: inline-block;
    width: 50%;
    padding-bottom: 50px;
    pointer-events: none;

    div{
      width: 100%;
      display: inline-block;
    }

    img{
      position: absolute;
      width: 60px;
      left: 0;
      top: 0;
      opacity: 0;
      transition: .5s .5s opacity,.5s .5s transform;
      transform: translateY(100px);
      &.show{
        opacity: 1;
      }
    }

    .tarifa-valle{
      transform: translateX(-120px)  translateY(100px);
    }
    .tarifa-punta{
      transform: translateX(120px)  translateY(100px);
    }

    .tarifa-valle.show{
      transform: translateX(-120px)  translateY(-10px);
    }
    .tarifa-punta.show{
      transform: translateX(120px)  translateY(0px);
    }
  }

  .contenedor-texto{
    width: 50%;
    text-align: left;
    padding-left: 50px;

    h2{
      margin-bottom: 20px;
    }
  }

  .consumos{
    margin-top: 50px;
  }

  .consumos article{
    width: 50%;
    padding-right: 20px;

    p{
      font-size: 12px;
    }
  }

  svg{
    border:1px solid;
  }

  @media screen and (max-width: 1100px){

    .container{
      -webkit-flex-direction: column;
      -moz-flex-direction: column;
      -ms-flex-direction: column;
      -o-flex-direction: column;
      flex-direction: column;
    }

    .contenedor-texto{
      width: 100%;
      order: -1;
      padding-left: 0;
      max-width: 500px;
    }

    .contenedor-grafico{
      width: 100%;
      margin-top: 50px;
    }

  }

  @media screen and (max-width: 550px){
    .contenedor-grafico{
      display: none;
    }

    .consumos{
      margin-top: 20px;
    }
  }

  @media screen and (max-width: 470px){

    .consumos article{
      width: 100%;
      margin-bottom: 10px;
    }

    h4{
      font-size: 18px;
    }

    p{
      font-size: 14px;
    }

  }




</style>



// WEBPACK FOOTER //
// src/components/view-parts/simulador/grafica-tu-perfil.vue